import React, { FC, Fragment } from "react";
import { makeStyles } from "@material-ui/core";
import { FormControlLabel } from "../core/FormControlLabel";
import { Checkbox } from "../core/Checkbox";
import { DefaultStyles, Colors } from "../../styles";
import { useStyles } from "../../useStyles";
import { useFormModel } from "../core/FormModelHelpes";
import { ChangeNames } from "../../clients/FirebaseClient/types";

const useCustomStyles = makeStyles(() => {
    const styles = DefaultStyles;
    return {
        p: {
            ...styles.p,
            paddingLeft: 16,
        },

        helpText: {
            ...styles.p,
            paddingLeft: 43,
            color: Colors.anthracite50,
        },
    };
});

export const NewConnectionMultilineContactAllowedForm: FC = () => {
    const classes = useStyles();
    const customClasses = useCustomStyles();

    const { values, setValues } = useFormModel<
        ChangeNames.NEW_CONNECTION_MULTILINE_CONTACT_ALLOWED
    >();

    return (
        <Fragment>
            <h4 className={classes.h4} style={{ marginBottom: 16, marginTop: 40 }}>
                Erteilen Sie uns bitte Ihre Kontakterlaubnis
            </h4>
            <FormControlLabel
                isCheckBox={true}
                label="Ich bin damit einverstanden, dass mich die Syna zur individuellen Kundenberatung für Hauseinführungssysteme telefonisch oder per E-Mail kontaktieren darf."
                labelPlacement="end"
                control={
                    <Fragment>
                        <Checkbox
                            value="ja"
                            checked={values.newConnectionMultilineContactAllowed.value.yes}
                            onChange={(event, checked) =>
                                setValues(values => {
                                    values.newConnectionMultilineContactAllowed.value = {
                                        yes: checked,
                                        no: !checked,
                                    };
                                })
                            }
                        />
                    </Fragment>
                }
                error={values.newConnectionMultilineContactAllowed.error !== null}
            />
            <p className={customClasses.helpText}>
                Ich bin berechtigt, der Nutzung der dafür erforderlichen Daten jederzeit gegenüber
                der Syna über nachfolgende Kontaktmöglichkeiten zu widersprechen, ohne dass hierfür
                andere als die Übermittlungskosten nach den Basistarifen entstehen:
            </p>
            <p className={customClasses.helpText} style={{ marginBottom: 0 }}>
                Syna GmbH, Ludwigshafener Str. 4, 65929 Frankfurt am Main
            </p>
            <p className={customClasses.helpText} style={{ marginTop: 0 }}>
                Telefon: 069 3107 – 1500, E-Mail: anschlusswesen@syna.de
            </p>
        </Fragment>
    );
};
